module.exports = __webpack_public_path__ + "static/img/4.a4019b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/4.png
// module id = 7HQ7
// module chunks = 38